<template>
  <div class="room">
      <blue-print :bridgeId="bridgeId"></blue-print>
  </div>
</template>
<script>
import BluePrint from '../../components/BluePrint'

export default {
  name: 'bridgeImg',
  components: { BluePrint },
  data() {
    return {
        bridgeId: 'ffaa13fe-473e-4827-a8fd-b89b8fdd3899'
    }
  },
}
</script>